import { render } from "./EventCardsUsers.vue?vue&type=template&id=7063076a&scoped=true"
import script from "./EventCardsUsers.vue?vue&type=script&lang=js"
export * from "./EventCardsUsers.vue?vue&type=script&lang=js"

import "./EventCardsUsers.vue?vue&type=style&index=0&id=7063076a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7063076a"]])

export default __exports__